import styled from 'styled-components';

export const Container = styled.div`
  @media screen and (max-width: 1185px) {
    padding: 0 20px;

    .thumb-desktop {
      display: none;
    }

    h2 {
      display: none;
    }

    .subtitle {
      display: none;
    }

    .header-content-mobile {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 40px;

      img {
        width: 183px;
      }

      h3 {
        font-size: 18px;
        text-transform: uppercase;
        font-family: 'Inter Light';
      }
    }

    p {
      font-family: 'Inter Light';
      font-size: 16px;
      line-height: 28px;
      white-space: pre-line;
      margin: 20px 0;
    }

    iframe {
      height: 289px;
      width: 100%;
    }
  }
  @media screen and (min-width: 1186px) {
    //DESKTOP

    margin: 70px 0 0;

    .thumb-desktop {
      justify-self: center;
      width: 75%;
    }

    .header-content-mobile {
      display: none;
    }

    div {
      h2 {
        font-size: 34px;
        line-height: 48px;
        color: var(--primary-color);
        font-family: 'Inter ExtraBold';
        margin-bottom: 10px;
      }

      h3 {
        font-size: var(--font-large);
        font-family: 'Inter Light';
      }
      p {
        font-family: 'Inter Light';
        font-size: 16px;
        line-height: 28px;
        white-space: pre-line;
        margin: 40px 0;
      }
    }
  }

  .title-wrapper {
    text-align: center;
    margin-bottom: 35px;
  }

  .video-wrapper {
    margin-bottom: -180px;
  }

  .container-sambaVideos {
    > div {
      text-align: center;

      iframe {
        border-radius: 15px;
      }
    }
  }

  .content-section {
    background: var(--color-light-pink);
    padding-top: 180px;
    padding-bottom: 40px;
  }
`;

export const Alerts = styled.div`
  > div {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    padding: 20px;
    margin-bottom: 20px;

    .icon-title {
      display: flex;
      align-items: center;
      flex-direction: initial;
    }

    h4 {
      color: var(--primary-color);
      font-family: 'Inter Bold';
      font-size: 20px;
    }

    p {
      margin-top: 15px;
      margin-bottom: 0;
      font-size: 16px;
      line-height: 21px;
      word-break: break-all;
    }

    .alert-medication {
      margin: 0;
      font-size: 16px;
      span {
        font-family: 'Inter ExtraBold';
        font-weight: bold;
      }
    }

    img {
      margin-right: 16px;
    }
  }
`;

export const ContainerBtn = styled.div`
  @media screen and (min-width: 1024px) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0;

    button {
      max-width: 230px;
      width: 100%;
      text-transform: uppercase;
      font-weight: 600;
      background: var(--secondary-color);
    }
  }
`;

export const Player = styled.div`
  @media screen and (min-width: 1186px) {
    #player {
      width: 100%;
      height: 22vw;
      max-height: 341px;
      background-color: #b924810d;

      iframe {
        height: 100%;
        width: 100%;
      }
    }
  }
`;

export const ContainerImgInfo = styled.div`
  padding: 60px 0;

  img {
    margin: 0 auto;
    display: block;
    max-width: 100%;
  }

  @media screen and (max-width: 600px) {
    max-width: 600px;
    width: 100%;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 60px;

  .thumb-wrapper {
    width: 40%;

    @media screen and (max-width: 1185px) {
      display: none;
    }
  }

  .info-wrapper {
    width: 60%;

    @media screen and (max-width: 1185px) {
      width: 100%;
    }
  }
`;